import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

/**
 * Vista móvil de Gestión
 * Botones apilados verticalmente con mucho espacio táctil
 */
export const GestionMovilView: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleOperacion = () => {
    navigate('/gestion/operacion');
  };

  const handleConsumos = () => {
    navigate('/gestion/consumos');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 pb-20">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900 mb-1">{t('management.title')}</h1>
        <p className="text-sm text-gray-600">
          {t('management.operation')} / {t('management.consumption')}
        </p>
      </div>

      {/* Contenido Principal */}
      <div className="space-y-4">
        {/* Card Operación */}
        <button
          onClick={handleOperacion}
          className="w-full group relative bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 active:scale-95 overflow-hidden"
        >
          {/* Fondo decorativo */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-400 to-blue-600 opacity-10 rounded-full -mr-16 -mt-16" />

          {/* Contenido */}
          <div className="relative p-6 text-left">
            {/* Icono */}
            <div className="mb-4 inline-block p-3 bg-blue-100 rounded-lg group-active:bg-blue-200 transition-colors">
              <svg
                className="w-6 h-6 text-blue-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                />
              </svg>
            </div>

            {/* Titulo y descripción */}
            <h2 className="text-xl font-bold text-gray-900 mb-2">
              Operación
            </h2>
            <p className="text-sm text-gray-600 mb-4">
              Uso de máquinas, calendario de operaciones y análisis de horas disponibles vs utilizadas.
            </p>

            {/* Características */}
            <ul className="space-y-1 mb-4">
              <li className="flex items-center text-xs text-gray-700">
                <span className="w-1.5 h-1.5 bg-blue-500 rounded-full mr-2"></span>
                Calendario de horas por día
              </li>
              <li className="flex items-center text-xs text-gray-700">
                <span className="w-1.5 h-1.5 bg-blue-500 rounded-full mr-2"></span>
                Gráfico Gantt
              </li>
            </ul>

            {/* Botón */}
            <div className="inline-block w-full">
              <span className="inline-block w-full text-center px-4 py-3 bg-blue-600 text-white rounded-lg group-active:bg-blue-700 transition-colors font-medium text-sm">
                Ver Operación →
              </span>
            </div>
          </div>
        </button>

        {/* Card Consumos */}
        <button
          onClick={handleConsumos}
          className="w-full group relative bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 active:scale-95 overflow-hidden"
        >
          {/* Fondo decorativo */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-green-400 to-green-600 opacity-10 rounded-full -mr-16 -mt-16" />

          {/* Contenido */}
          <div className="relative p-6 text-left">
            {/* Icono */}
            <div className="mb-4 inline-block p-3 bg-green-100 rounded-lg group-active:bg-green-200 transition-colors">
              <svg
                className="w-6 h-6 text-green-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 10V3L4 14h7v7l9-11h-7z"
                />
              </svg>
            </div>

            {/* Titulo y descripción */}
            <h2 className="text-xl font-bold text-gray-900 mb-2">
              Consumos
            </h2>
            <p className="text-sm text-gray-600 mb-4">
              Analiza el consumo de insumos, combustible y lubricantes en línea temporal.
            </p>

            {/* Características */}
            <ul className="space-y-1 mb-4">
              <li className="flex items-center text-xs text-gray-700">
                <span className="w-1.5 h-1.5 bg-green-500 rounded-full mr-2"></span>
                Gráficos de consumo por insumo
              </li>
              <li className="flex items-center text-xs text-gray-700">
                <span className="w-1.5 h-1.5 bg-green-500 rounded-full mr-2"></span>
                Línea temporal
              </li>
            </ul>

            {/* Botón */}
            <div className="inline-block w-full">
              <span className="inline-block w-full text-center px-4 py-3 bg-green-600 text-white rounded-lg group-active:bg-green-700 transition-colors font-medium text-sm">
                Ver Consumos →
              </span>
            </div>
          </div>
        </button>
      </div>
    </div>
  );
};

export default GestionMovilView;
